// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-container[data-v-18049b75] {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  gap: 10px;\n  margin-top: 10px;\n}\n.laws-items[data-v-18049b75] {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.law-item[data-v-18049b75] {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.law-item p[data-v-18049b75] {\n    flex: 1;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
